module.exports = __webpack_public_path__ + "img/category-casino.747d6c3b.png";